import PropTypes from 'prop-types';
import equipmentIcon from '../../icons/icon_equipment.png';
import tankIcon from '../../icons/icon_tank.png';
import meterIcon from '../../icons/icon_meter.png';
import wellIcon from '../../icons/icon_well.png';

export const PROP_TYPES = {
  ROUTE_DATA_STOP: PropTypes.exact({
    stopId: PropTypes.string,
    stopName: PropTypes.string,
    xid: PropTypes.string,
    userTimings: PropTypes.string,
    durationInMinutes: PropTypes.number,
    numberOfTasks: PropTypes.number,
    location: PropTypes.exact({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  }),
  ROUTE_DATA_LOCATION: PropTypes.exact({
    location: PropTypes.exact({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    time: PropTypes.string,
  }),
  get ROUTE_DATA() {
    return PropTypes.exact({
      stops: PropTypes.arrayOf(this.ROUTE_DATA_STOP),
      locations: PropTypes.arrayOf(this.ROUTE_DATA_LOCATION),
    });
  },
  get PLANNED_AND_ACTUAL_ROUTE_DATA() {
    return PropTypes.exact({
      planned: this.ROUTE_DATA,
      actual: this.ROUTE_DATA,
      isLoading: PropTypes.bool.isRequired,
    });
  },
};
const dashedLineSymbol = {
  path: 'M 0,-1 0,1',
  strokeOpacity: 0.75,
  scale: 3,
};
export const ACTUAL_VS_PLANNED_PROPERTY = {
  ACTUAL: { color: '#009574', strokeOpacity: 0.75 },
  PLANNED: {
    color: '#147',
    strokeOpacity: 0.75,
  },
};
export const PATH_TYPE = {
  RESOLVED: 'PATH_TYPE_RESOLVED',
  UNRESOLVED: 'PATH_TYPE_UNRESOLVED',
};
export const STOP_TYPE = {
  TASK_STOP: 'STOP_TYPE_TASK_STOP',
  USER_START_END_STOP: 'STOP_TYPE_USER_START_END_STOP',
  USER_CURRENT_LOCATION_STOP: 'STOP_TYPE_USER_CURRENT_LOCATION_STOP',
};
export const USER_LOCATION_TYPE = {
  START_LOCATION: 'USER_LOCATION_TYPE_START_LOCATION',
  END_LOCATION: 'USER_LOCATION_TYPE_END_LOCATION',
  CURRENT_LOCATION: 'USER_LOCATION_TYPE_CURRENT_LOCATION',
};
export const PATH_PROPERTY = {
  [PATH_TYPE.RESOLVED]: {
    icons: [],
    strokeOpacity: 0.75,
    strokeWeight: 2,
  },
  [PATH_TYPE.UNRESOLVED]: {
    icons: [
      {
        icon: dashedLineSymbol,
        offset: '0',
        repeat: '20px',
      },
    ],
    strokeOpacity: 0,
    strokeWeight: 2,
  },
};

export const userIconSvg = (selected = false) => {
  if (!selected) {
    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="65" viewBox="0 0 66 71">
  <defs>
      <filter id="ni6el9yjsa" width="278.1%" height="251.6%" x="-89.1%" y="-59.2%" filterUnits="objectBoundingBox">
          <feMorphology in="SourceAlpha" operator="dilate" radius="1.5" result="shadowSpreadOuter1"/>
          <feOffset dy="6" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8"/>
          <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
          <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.909803922 0 0 0 0 0.909803922 0 0 0 0 0.909803922 0 0 0 1 0"/>
      </filter>
      <path id="ra6ga9yztb" d="M27.325 4.596c-6.233-6.128-16.417-6.128-22.65 0-6.233 6.129-6.233 16.141 0 22.27L16 38l11.325-11.135c6.233-6.128 6.233-16.054 0-22.269z"/>
  </defs>
  <g fill="none" transform="translate(17 11)">
      <use fill="#000" filter="url(#ni6el9yjsa)" xlink:href="#ra6ga9yztb"/>
      <path fill="#147" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" d="M32.75 15.763c0 4.218-1.632 8.425-4.9 11.637L16 39.052 4.15 27.4C.882 24.19-.75 19.96-.75 15.73c0-4.228 1.633-8.457 4.9-11.669C7.41.855 11.704-.75 16-.75S24.59.855 27.855 4.065c3.264 3.255 4.895 7.483 4.895 11.698z"/>
      <g fill="#FFF">
          <path d="M9 0c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 5.077c-1.374 0-2.538 1.125-2.538 2.692 0 .912.295 1.506.923 2.1.226.187.402.403.527.641.252.477.28.97.183 1.42-.02.091-.042.164-.042.156-.218.81-.782 1.157-2.019 1.58l-.411.139c-.16.054-.285.098-.404.142-.587.216-1.008.437-1.312.713 1.35 1.216 3.135 1.955 5.093 1.955 1.958 0 3.743-.738 5.092-1.952-.302-.27-.72-.483-1.314-.696-.103-.037-.211-.075-.348-.12l-.356-.12c-1.288-.435-1.868-.786-2.118-1.608-.015-.05-.034-.119-.05-.207-.078-.41-.06-.853.127-1.29.122-.284.31-.539.543-.734.66-.596.962-1.206.962-2.119 0-1.54-1.181-2.692-2.538-2.692zm0-3.692c-4.206 0-7.615 3.41-7.615 7.615 0 1.748.588 3.358 1.578 4.643.453-.415 1.03-.72 1.777-.995.132-.05.268-.097.438-.154l.409-.138c.797-.273 1.08-.447 1.148-.69l.007-.03c.034-.159.024-.331-.054-.48-.04-.077-.1-.15-.22-.25-.921-.869-1.391-1.813-1.391-3.137 0-2.342 1.795-4.077 3.923-4.077 2.114 0 3.923 1.765 3.923 4.077 0 1.328-.482 2.3-1.439 3.164-.085.071-.141.148-.178.235-.063.147-.07.324-.04.486l.012.051c.07.234.376.42 1.238.71l.355.119c.146.049.262.09.376.13.76.273 1.337.57 1.789.98.99-1.285 1.58-2.896 1.58-4.644 0-4.206-3.41-7.615-7.616-7.615z" transform="translate(7 7)"/>
      </g>
  </g>
  </svg>`;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="65" viewBox="0 0 66 71">
    <defs>
        <filter id="ni6el9yjsa" width="278.1%" height="251.6%" x="-89.1%" y="-59.2%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius="1.5" result="shadowSpreadOuter1"/>
            <feOffset dy="6" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.909803922 0 0 0 0 0.909803922 0 0 0 0 0.909803922 0 0 0 1 0"/>
        </filter>
        <path id="ra6ga9yztb" d="M27.325 4.596c-6.233-6.128-16.417-6.128-22.65 0-6.233 6.129-6.233 16.141 0 22.27L16 38l11.325-11.135c6.233-6.128 6.233-16.054 0-22.269z"/>
    </defs>
    <g fill="none" transform="translate(17 11)">
        <use fill="#000" filter="url(#ni6el9yjsa)" xlink:href="#ra6ga9yztb"/>
        <path fill="#FFF" fill-rule="evenodd" stroke="#147" stroke-width="1.5" d="M32.75 15.763c0 4.218-1.632 8.425-4.9 11.637L16 39.052 4.15 27.4C.882 24.19-.75 19.96-.75 15.73c0-4.228 1.633-8.457 4.9-11.669C7.41.855 11.704-.75 16-.75S24.59.855 27.855 4.065c3.264 3.255 4.895 7.483 4.895 11.698z"/>
        <g fill="#147">
            <path d="M9 0c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 5.077c-1.374 0-2.538 1.125-2.538 2.692 0 .912.295 1.506.923 2.1.226.187.402.403.527.641.252.477.28.97.183 1.42-.02.091-.042.164-.042.156-.218.81-.782 1.157-2.019 1.58l-.411.139c-.16.054-.285.098-.404.142-.587.216-1.008.437-1.312.713 1.35 1.216 3.135 1.955 5.093 1.955 1.958 0 3.743-.738 5.092-1.952-.302-.27-.72-.483-1.314-.696-.103-.037-.211-.075-.348-.12l-.356-.12c-1.288-.435-1.868-.786-2.118-1.608-.015-.05-.034-.119-.05-.207-.078-.41-.06-.853.127-1.29.122-.284.31-.539.543-.734.66-.596.962-1.206.962-2.119 0-1.54-1.181-2.692-2.538-2.692zm0-3.692c-4.206 0-7.615 3.41-7.615 7.615 0 1.748.588 3.358 1.578 4.643.453-.415 1.03-.72 1.777-.995.132-.05.268-.097.438-.154l.409-.138c.797-.273 1.08-.447 1.148-.69l.007-.03c.034-.159.024-.331-.054-.48-.04-.077-.1-.15-.22-.25-.921-.869-1.391-1.813-1.391-3.137 0-2.342 1.795-4.077 3.923-4.077 2.114 0 3.923 1.765 3.923 4.077 0 1.328-.482 2.3-1.439 3.164-.085.071-.141.148-.178.235-.063.147-.07.324-.04.486l.012.051c.07.234.376.42 1.238.71l.355.119c.146.049.262.09.376.13.76.273 1.337.57 1.789.98.99-1.285 1.58-2.896 1.58-4.644 0-4.206-3.41-7.615-7.616-7.615z" transform="translate(7 7)"/>
        </g>
    </g>
    </svg>`;
};

export const stopIconSvg = () => {
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="60" viewBox="0 0 48 60">
    <defs>
        <filter id="rbjbcfpwta" width="150%" height="148.2%" x="-25%" y="-15.7%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius="2" result="shadowSpreadOuter1"/>
            <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.909803922 0 0 0 0 0.909803922 0 0 0 0 0.909803922 0 0 0 1 0"/>
        </filter>
        <path id="g2qkia463b" d="M2 0h32c1.105 0 2 .895 2 2v32.155c0 1.105-.895 2-2 2-.046 0-.092-.001-.138-.005-5.775-.4-9.798-.346-12.072.163-2.543.568-4.84 3.293-6.89 8.172-1.838-4.945-3.564-7.67-5.178-8.172-1.362-.425-3.883-.491-7.564-.2-1.1.088-2.064-.733-2.152-1.834C.002 34.226 0 34.173 0 34.12V2C0 .895.895 0 2 0z"/>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(6 4)">
        <use fill="#000" filter="url(#rbjbcfpwta)" xlink:href="#g2qkia463b"/>
        <path fill="#835A99" stroke="#FFF" stroke-width="2" d="M34-1c.828 0 1.578.336 2.121.879C36.664.422 37 1.172 37 2h0v32.155c0 .829-.336 1.579-.879 2.121-.543.543-1.293.88-2.121.88-5.84-.398-9.771-.364-11.991.133-2.341.523-4.334 3.172-6.188 7.584-.376.896-.697 1.745-.958 2.546-.255-.796-.557-1.659-.9-2.585-1.641-4.415-3.06-7.106-4.538-7.567-1.295-.403-3.695-.434-7.187-.156-.826.065-1.6-.21-2.185-.708-.594-.507-.992-1.245-1.047-2.089h0L-1 2c0-.828.336-1.578.879-2.121C.422-.664 1.172-1 2-1h0z"/>
        <text fill="#FFF" style="font-family:JoynFontBook,sans-serif;" font-size="16" font-weight="600">
            <tspan x="13" y="24">S</tspan>
        </text>
    </g>
</svg>`;
};

export const taskIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="29" height="33" viewBox="0 0 29 33">
<g fill="none" fill-rule="evenodd">
    <rect width="29" height="33" fill="#FFF" fill-opacity=".266" rx="3.5"/>
    <path fill="#a2a29f" fill-rule="nonzero" d="M8.25 6.833v-1.61h3.125c0-1.78 1.4-3.223 3.125-3.223 1.726 0 3.125 1.443 3.125 3.222h3.125v1.611c0 .89-.7 1.611-1.563 1.611H9.813c-.862 0-1.562-.72-1.562-1.61zm14.844-1.53v1.53c-.003 2.224-1.75 4.026-3.907 4.028H9.813C7.656 10.86 5.91 9.057 5.906 6.833v-1.53C3.654 5.693 2.003 7.701 2 10.056v16.11C2 28.837 4.099 31 6.688 31h15.625C24.9 31 27 28.836 27 26.167V10.056c-.003-2.355-1.654-4.364-3.906-4.753z"/>
</g>
</svg>
`;

export const flagIconSvg = (actual = false) => {
  return `<?xml version="1.0" encoding="UTF-8"?>
    <svg width="26px" height="36px" viewBox="0 0 26 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>taskFlag</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Joyn-2-Map-zoom-User-Selected" transform="translate(-801.000000, -524.000000)" fill="${
              actual ? '#009574' : '#265482'
            }" fill-rule="nonzero">
                <g id="taskFlag" transform="translate(801.000000, 524.000000)">
                    <rect id="Rectangle" x="0" y="1" width="2" height="35"></rect>
                    <path d="M3,1.39560488 C3,6.46610274 3,9.54140469 3,14.5969011 C13.2347582,19.4573783 15.749124,9.73642384 26,14.5969011 C26,9.52640322 26,6.45110126 26,1.39560488 C15.749124,-3.44987089 13.2186405,6.27108359 3,1.39560488 Z" id="Path"></path>
                </g>
            </g>
        </g>
    </svg>`;
};

export const taskCountSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="29" height="33" viewBox="0 0 29 33">
<g fill="none" fill-rule="evenodd">
    <rect width="29" height="33" fill="#FFF" fill-opacity=".266" rx="3.5"/>
    <path fill="#424F62" fill-rule="nonzero" d="M8.25 6.833v-1.61h3.125c0-1.78 1.4-3.223 3.125-3.223 1.726 0 3.125 1.443 3.125 3.222h3.125v1.611c0 .89-.7 1.611-1.563 1.611H9.813c-.862 0-1.562-.72-1.562-1.61zm14.844-1.53v1.53c-.003 2.224-1.75 4.026-3.907 4.028H9.813C7.656 10.86 5.91 9.057 5.906 6.833v-1.53C3.654 5.693 2.003 7.701 2 10.056v16.11C2 28.837 4.099 31 6.688 31h15.625C24.9 31 27 28.836 27 26.167V10.056c-.003-2.355-1.654-4.364-3.906-4.753z"/>
</g>
</svg>
`;

export const selectedStopIconSvg = () => {
  return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="63" viewBox="0 0 50 63">
<defs>
    <filter id="k6opnu9e2a" width="150%" height="150.1%" x="-25%" y="-18%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" operator="dilate" radius="2.5" result="shadowSpreadOuter1"/>
        <feOffset dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.635294118 0 0 0 0 0.635294118 0 0 0 0 0.62745098 0 0 0 0.6 0"/>
    </filter>
    <path id="bk3tgpelhb" d="M2 0h32c1.105 0 2 .895 2 2v32.155c0 1.105-.895 2-2 2-.046 0-.092-.001-.138-.005-5.775-.4-9.798-.346-12.072.163-2.543.568-4.84 3.293-6.89 8.172-1.838-4.945-3.564-7.67-5.178-8.172-1.362-.425-3.883-.491-7.564-.2-1.1.088-2.064-.733-2.152-1.834C.002 34.226 0 34.173 0 34.12V2C0 .895.895 0 2 0z"/>
</defs>
<g fill="none" fill-rule="evenodd">
    <g stroke-linejoin="round" transform="translate(7 6)">
        <use fill="#000" filter="url(#k6opnu9e2a)" xlink:href="#bk3tgpelhb"/>
        <path fill="#E0D2E7" stroke="#835A99" stroke-width="2.5" d="M34-1.25c.897 0 1.71.364 2.298.952.588.588.952 1.4.952 2.298h0v32.155c0 .898-.364 1.71-.952 2.298-.588.588-1.4.952-2.298.952-5.822-.396-9.73-.366-11.937.128-2.29.511-4.207 3.141-6.011 7.437-.494 1.175-.893 2.269-1.186 3.278-.3-.993-.684-2.104-1.138-3.327-1.591-4.282-2.932-6.964-4.378-7.415-1.278-.398-3.648-.42-7.093-.146-.894.071-1.733-.227-2.366-.767-.646-.55-1.077-1.353-1.135-2.27h0L-1.25 2c0-.897.364-1.71.952-2.298C.29-.886 1.102-1.25 2-1.25h0z"/>
    </g>
    <text fill="#424F62" style="font-family:JoynFontBook,sans-serif;" font-size="16" font-weight="600" transform="translate(7 6)">
        <tspan x="13.5" y="26">S</tspan>
    </text>
</g>
</svg>
`;
};
export const ICON_MAP = {
  equipment: equipmentIcon,
  tank: tankIcon,
  meter: meterIcon,
  well: wellIcon,
  stop: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABWUlEQVQ4jYWSsUoDQRRFz0xWraz0H6y0UPEfhECSLaaxstXC4G8ogikUQRQELXUH7SwFwU6Cld8QE6M2myXvWbjGdd2Nr5q5794zb4YxFFQURfPAtoEVAAMPVmSvGoZPea/JC977NVRPgYlca6CwXq/XL0oB3vs5VNvAZCppzhcPRRbCMHz+ztgsQFU3M+GrShDMxIPBLKo+1aYqxmxkM78ABhZHjUqlWa1We865biCy9ZOwS6UAjHnLTDM9WhszWqPaz0aC3BVuDawCIHJyfXnZBBha28occlM6gYicAe8ACiti7b1Yew8sp5YOcF4KCMPwxUCLslLdqdVq76UAgKHqLtAriHfiJDnIi38AjUbjFdW/U6juOOc+/gUAxEnSIn2LtPpxkhwVeQsBzrkuxhx+7w3sO+f6Rd5CAICIHPL1lVXguMw3tnwUtb33j+M8wbimwh2q4yx8AqwkhG9i9qP6AAAAAElFTkSuQmCC',
};

export const skillIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
<path fill="#A2A2A0" d="M1332 332L1328.667 332 1328.667 327 1324 334 1327.333 334 1327.333 339z" transform="translate(-1324 -327)"/>
</svg>
`;

export const availabilityIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15">
<g fill="#A2A2A0">
    <path d="M10.649 2.97l.146.11c.274.207.66.148.863-.131.203-.28.145-.673-.13-.879L10.11 1.004c-.275-.207-.661-.147-.864.132-.203.279-.145.672.13.878l.146.11-.426.585c-.737-.49-1.59-.816-2.505-.927v-.526h.181c.341 0 .618-.281.618-.628S7.113 0 6.772 0H5.007c-.341 0-.617.281-.617.628s.276.628.617.628h.182v.526c-.917.11-1.768.436-2.506.927l-.425-.585.146-.11c.275-.206.332-.6.13-.878-.203-.28-.59-.338-.864-.132L.25 2.07c-.274.206-.332.6-.13.879.203.279.59.338.864.132l.147-.11.477.657C.618 4.7.008 6.136.008 7.718c0 3.299 2.638 5.983 5.882 5.983 3.243 0 5.882-2.684 5.882-5.983 0-1.582-.61-3.019-1.6-4.09l.477-.657zm-.288 4.748c0 2.507-2.006 4.547-4.471 4.547-2.465 0-4.47-2.04-4.47-4.547 0-2.507 2.005-4.547 4.47-4.547s4.47 2.04 4.47 4.547z" transform="translate(.688 .083)"/>
    <path d="M5.89 4.09v7.256c1.966 0 3.567-1.628 3.567-3.628S7.857 4.09 5.89 4.09z" transform="translate(.688 .083)"/>
</g>
</svg>
`;

export const usercardTaskIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
<path fill="#A2A2A0" d="M2.5 2v-.667h1.25C3.75.597 4.31 0 5 0s1.25.597 1.25 1.333H7.5V2c0 .368-.28.667-.625.667h-3.75C2.78 2.667 2.5 2.368 2.5 2zm5.938-.633V2c-.001.92-.7 1.666-1.563 1.667h-3.75C2.262 3.666 1.563 2.92 1.562 2v-.633c-.9.16-1.56.992-1.562 1.966V10c0 1.105.84 2 1.875 2h6.25C9.161 12 10 11.105 10 10V3.333c-.001-.974-.662-1.805-1.563-1.966z"/>
</svg>
`;
export const smallChequeredFlag = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12">
<g fill="none" fill-rule="evenodd">
    <g fill="#FFF" fill-rule="nonzero">
        <g>
            <g>
                <g>
                    <path d="M0 .333H1V12H0zM1.038.465v4.4c3.543 1.62 4.414-1.62 7.962 0v-4.4C5.452-1.15 4.576 2.09 1.038.465z" transform="translate(-1021 -589) translate(791 554) translate(220 26) translate(10 9)"/>
                </g>
            </g>
        </g>
    </g>
</g>
</svg>
`;

export const SHAPE_TYPE = {
  CIRCLE: 'circle',
  RECTANGLE: 'rectangle',
  POLYGON: 'polygon',
};
